import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";

function FooterNew() {
  const [value, setValue] = useState("");

  useEffect(() => {
    if (typeof window !== "undefined") {
      setValue(localStorage.getItem("access_token"));
    }
  }, []);

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="new_foot">
      <nav className="bottom-nav">
        <Link to="/">
          <i className="fas fa-home"></i>
          <span>Home</span>
        </Link>
        <a
          href="https://wa.me/919358333909"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-whatsapp"></i>
          <span>WhatsApp</span>
        </a>
        <Link to={value ? "/visit-site" : "/login"}>
          <i className="fas fa-plus-circle"></i>
          <span>Vistors</span>
        </Link>
        <Link to={value ? "/dashboard" : "/login"}>
          <i className="fas fa-user"></i>
          <span>Dashboard</span>
        </Link>
      </nav>
    </div>
  );
}

export default FooterNew;
